import React, { useMemo } from "react";
import { Nav } from "react-bootstrap";
import "./BurgerMenu.scss";

// imports image
import { useLocation, useNavigate } from "react-router-dom";
import { localStorageKeys } from "config/localStorageKeys";

interface Props {
  viewOpenLeftMenu?: boolean;
  handleClickCloseLeftMenu?: () => void;
}

const BurgerMenuMobile = ({ viewOpenLeftMenu, handleClickCloseLeftMenu }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isMainPage = useMemo(() => {
    return (
      location.pathname === "/main_page" ||
      location.pathname === "/my_profile" ||
      location.pathname === "/help" ||
      location.pathname === "/payment" ||
      location.pathname === "/contact" ||
      location.pathname === "/by_hand_play_exercise" ||
      location.pathname === "/by_deffence_exercise" ||
      location.pathname === "/educational_video"
    );
  }, [location.pathname]);

  if (!viewOpenLeftMenu) return null;

  const isFixedTopPage =
    location.pathname === "/tricks_play" ||
    location.pathname === "/deffense_play" ||
    location.pathname === "/hand_play" ||
    location.pathname === "/def_lead_play" ||
    location.pathname === "/bidding_interactive" ||
    location.pathname === "/by_hand_exercise" ||
    location.pathname === "/by_summary" ||
    location.pathname === "/bidding";

  return (
    <div
      className="wrapper-burrger-menu"
      style={{ height: document.body.scrollHeight, top: isFixedTopPage ? 52 : 5 }}>
      <div
        className={`fon-burger-menu ${isMainPage ? "top50" : ""}`}
        onClick={handleClickCloseLeftMenu}></div>
      <div className={`left-menu-main-wrapper burger-menu-mobile ${isMainPage ? "top50" : ""}`}>
        <div className="navbar-main-left-menu">
          <a
            role="button"
            href="#"
            onClick={() => {
              navigate("/my_profile");
              handleClickCloseLeftMenu && handleClickCloseLeftMenu();
            }}
            className="nav-item nav-link">
            החשבון שלי
          </a>
          <Nav.Link
            onClick={() => {
              navigate("/my_profile?tab=Settings");
              handleClickCloseLeftMenu && handleClickCloseLeftMenu();
            }}
            className="nav-item">
            הגדרות
          </Nav.Link>
          <Nav.Link onClick={() => navigate("/help")} className="nav-item">
            עזרה
          </Nav.Link>
          <Nav.Link onClick={() => navigate("/educational_video")} className="nav-item">
            וידאו
          </Nav.Link>
          <Nav.Link onClick={() => navigate("/payment")} className="nav-item">
            רכישת מנוי
          </Nav.Link>
          {/* <Nav.Link
            onClick={() => {
              window.open("https://members.gobeb.co.il/Login.aspx", "_blank");
            }}
            className="nav-item">
            לאתר הישן
          </Nav.Link> */}
          <Nav.Link className="nav-item" onClick={() => navigate("/contact")}>
            צרו קשר
          </Nav.Link>
          <Nav.Link className="nav-item" onClick={() => navigate("/terms_privacy")}>
            תנאי שימוש
          </Nav.Link>
          <Nav.Link
            onClick={() => {
              localStorage.setItem(localStorageKeys.userInfo, "");
              navigate("/");
            }}
            className="nav-item">
            התנתקות
          </Nav.Link>
          {/*  */}
        </div>
      </div>
    </div>
  );
};

export default BurgerMenuMobile;
